import React, { FC } from 'react';
import '../../views/writing/slice/slice';
import { FitText } from '../FitText/FitText';

type CardProps = {
  id: any,
  content: any,
  style: any,
};

export const WordFromList: FC<CardProps> = ({ content, id, style }) => (
  <>
    {/* Długi zwrot dostaje mniejszą czcionkę, żeby zmieścił się w karcie (na telefonie) */}
    <FitText
      className="word"
      id={id}
      style={style}
    >
      {content}
    </FitText>
  </>
);

export default WordFromList;
